<template>
  <v-row
    class="asc-custom-alerts--header justify-end"
    :class="{ isSticky: isSticky }"
    no-gutters
  >
    <v-col class="customAlertControls" cols="6">
      <asc-accent-button
        :outline="!getSaveDisabled"
        secondary
        :on-click="handleCancel"
        button-text="Cancel"
        :disabled="false"
      ></asc-accent-button>
      <asc-accent-button
        :button-text="getButtonText"
        :on-click="handleSaveAlert"
        :loading="saveLoading"
        :disabled="getSaveDisabled"
      ></asc-accent-button>
    </v-col>
  </v-row>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscTooltip from '@/components/atoms/AscTooltip'

export default {
  name: 'AscDerivedParametersHeaderWrapper',

  components: {
    AscAccentButton,
    AscTooltip,
  },

  props: {
    title: {
      type: String,
      default: 'Custom Parameters',
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getButtonText() {
      return 'Save'
    },
    getSaveDisabled() {
      return this.saveDisabled
    },
  },

  methods: {
    handleSaveAlert() {
      this.$emit('handleSaveAlert')
    },
    handleCancel() {
      this.$emit('handleCancel')
    },
  },
}
</script>

<style lang="scss">
.asc-custom-alerts--header {
  .titleColumn {
    p {
      margin: 10px 0;
    }
  }

  &.isSticky {
    padding-right: 16px;

    .stickyFooter {
      padding: 0 15px;
    }
  }

  .customAlertControls {
    display: flex;
    justify-content: flex-end;

    .asc-accent-button-container {
      margin-top: 0;
      margin-right: 8px;
    }

    .asc-switch {
      margin-top: -6px;

      &.disabled {
        opacity: 0.3;
      }

      .v-input {
        .v-label {
          display: none;
        }
      }
    }
  }
}

.asc-sticky--container .asc-sticky.isSticky.stickyFooter {
  left: 48px !important;
  width: calc(100% - 48px) !important;
}
</style>
